import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Portfolio from "../../pages/Portfolio";
import AgentHome from "../../pages/AgentHome";
import About from "../../pages/About";
import HSPPlanet from "../../pages/HSPPlanet";
import IntranetConnections from "../../pages/IntranetConnections";
import AccessibilitySettings from "../../pages/AccessibilitySettings";
import DesignSystem from "../../pages/DesignSystem";
import ModelReno from "../../pages/ModelReno";
import RandomLifeNotes from "../../pages/RandomLifeNotes";
import DesignSystemGuide from "../../pages/DesignSystemGuide";
import Feedback from "../../pages/Feedback";
import AccessibilityPage from "../../pages/AccessibilityPage";
import Dreamcore from "../../pages/Dreamcore";
import Collabstr from "../../pages/Collabstr";
import Resume from "../../pages/Resume";
import HeroCompare from "../../pages/HeroCompare";
import KnowledgeBase from "../../pages/KnowledgeBase";
import GlanceAdmin from "../../pages/GlanceAdmin";
import { HeroA, HeroB, HeroC, HeroD } from "../../pages/HeroVariants";
import GoogleAnalytics from "../GoogleAnalytics";
import { useAgentDock } from "../../context/AgentDockContext";
import AgentDock from "./AgentDock";
import "./AppShell.css";

const DOCK_HIDDEN_PATHS = new Set([
  "/agent",
  "/admin",
  "/knowledge",
  "/a",
  "/b",
  "/c",
  "/d",
  "/hero-compare",
]);

export default function AppShell() {
  const { open, phase } = useAgentDock();
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  const dockHidden = DOCK_HIDDEN_PATHS.has(path);
  const dockOpen = open && !dockHidden;
  const dockPush =
    (phase === "push" ||
      phase === "dive" ||
      phase === "emerge" ||
      phase === "open") &&
    !dockHidden;

  return (
    <div
      className={`agent-app-shell${dockOpen ? " agent-app-shell--dock-open" : ""}${
        dockPush ? " agent-app-shell--dock-push" : ""
      }${phase === "push" ? " agent-app-shell--dock-animating" : ""}`}
    >
      <div className="agent-app-shell__main">
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/agent" element={<AgentHome />} />
          <Route path="/knowledge" element={<KnowledgeBase />} />
          <Route path="/admin" element={<GlanceAdmin />} />
          <Route path="/Collabstr" element={<Collabstr />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/HSPPlanet" element={<HSPPlanet />} />
          <Route path="/intranetconnections" element={<IntranetConnections />} />
          <Route path="/accessibilitySettings" element={<AccessibilitySettings />} />
          <Route path="/DesignSystem" element={<DesignSystem />} />
          <Route path="/ModelReno" element={<ModelReno />} />
          <Route path="/RandomLifeNotes" element={<RandomLifeNotes />} />
          <Route path="/design-system" element={<DesignSystemGuide />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/AccessibilityPage" element={<AccessibilityPage />} />
          <Route path="/world" element={<Dreamcore />} />
          <Route path="/A" element={<HeroA />} />
          <Route path="/B" element={<HeroB />} />
          <Route path="/C" element={<HeroC />} />
          <Route path="/D" element={<HeroD />} />
          <Route path="/hero-compare" element={<HeroCompare />} />
        </Routes>
      </div>
      {!dockHidden && <AgentDock />}
    </div>
  );
}
